module.exports = __webpack_public_path__ + "static/media/prop-8@2x-thumb.dd6c82bd.webp";